import { bookingResponse } from './bookingResponse';

export const ProviderAffilired = {
  bookingResponse,
};
